export default "__VITE_ASSET__AQWAnS4m__"